const CONTACT_REDUCER_PATH = "contactService";
const CONTACT_SERVICE_TAG = "Contact";
const DRAFT_CONTACT_SERVICE_TAG = "Draft-Contact";

const CONTACT_RELATED_TAGS = [CONTACT_SERVICE_TAG, DRAFT_CONTACT_SERVICE_TAG];

export { CONTACT_REDUCER_PATH, CONTACT_SERVICE_TAG, DRAFT_CONTACT_SERVICE_TAG, CONTACT_RELATED_TAGS };
